module.exports = __webpack_public_path__ + "media/images/athletes/1823-b74277cd6ff8b7d105345fe25e69ec9e.png";